<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Voyage Information</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6 v-if="newVoyage">
              <v-text-field :label="labels.voyNo" v-model="voyageForm.voyNo" :error-messages="errors.collect('voyNo')" v-validate="'required|param|max:6'" data-vv-name="voyNo" :data-vv-as="labels.voyNo"></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{labels.voyNoQuery}}</v-subheader>
              <div class="title">{{voyageForm.voyNo}}</div>
            </v-flex>
            <v-flex xs6>
              <v-text-field :label="labels.voyDet" v-model="voyageForm.voyDet" :error-messages="errors.collect('voyDet')" v-validate="'required|entry|max:120'" data-vv-name="voyDet" :data-vv-as="labels.voyDet"></v-text-field>
          </v-flex>
          <v-flex xs6>
              <cal-picker v-model="estDeptDate" :label="labels.estDeptDate" v-validate="'required'" :data-vv-as="labels.estDeptDate" data-vv-name="estDeptDate" :error-messages="errors.collect('estDeptDate')" @input="doEstDeptDate"></cal-picker>
            </v-flex>
            <v-flex xs6>
              <time-picker v-model="estDeptTime" :label="labels.estDeptTime" v-validate="'required'" :data-vv-as="labels.estDeptTime" data-vv-name="estDeptTime" :error-messages="errors.collect('estDeptTime')" @input="doEstDeptDate"></time-picker>
            </v-flex>
            <v-flex xs12>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                {{newVoyage? 'Add Voyage' : 'Update Voyage'}}
                <v-icon right>{{newVoyage? 'mdi-sale' : 'mdi-content-save'}}</v-icon>
                </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import toDate from 'date-fns/toDate'
import { formatDisplayTime } from '@/utils/date'
import { VESSEL_VOYAGE_TABMENU } from '@/store/types'
export default {
  data() {
    return {
      labels: {
        voyNo: 'Voyage No*',
        voyNoQuery: 'Voyage No',
        voyDet: 'Voyage Detail*',
        estDeptDate: 'Estimated Departure Date*',
        estDeptTime: 'Time*'
      },
      voyageForm: {
        vesNo: undefined,
        voyNo: undefined,
        voyDet: undefined,
        estDeptDate: undefined,
        estDeptTime: undefined
      },
      menu: [],
      newVoyage: false,
      submitting: false,
      estDeptDate: undefined,
      estDeptTime: undefined
    }
  },
  methods: {
    async doInit() {
      if (!this.newVoyage) {
        this.voyageForm.voyNo = this.voyNo
        this.voyageForm.vesNo = this.vesNo
        // Review
        if (this.voyNo) {
          await this.reviewVoyage()
        }
      }
    },
    async reviewVoyage() {
      const apiURI = this.$store.state.vessel.menu.getVslVoyage
      if (apiURI) {
        try {
          const expand = {
            vesNo: this.vesNo,
            voyNo: this.voyageForm.voyNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.voyageForm.vesNo = data.vslVoyage.vesNo
            this.voyageForm.voyNo = data.vslVoyage.voyNo
            this.voyageForm.voyDet = data.vslVoyage.voyDet
            this.voyageForm.estDeptDate = data.vslVoyage.estDeptDate
            if (this.voyageForm.estDeptDate) {
              this.estDeptDate = this.voyageForm.estDeptDate
              this.estDeptTime = formatDisplayTime(this.voyageForm.estDeptDate)
            }

            const commitData = {
              voyageTab: 1,
              displayVoyageReviewTab: true,
              vesNo: this.vesNo
            }
            this.$store.commit(VESSEL_VOYAGE_TABMENU, commitData)
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newVoyage) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.updateVslVoy
      if (apiURI) {
        this.voyageForm.vesNo = this.vesNo
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.voyageForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.reviewVoyage()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.vessel.menu.createVslVoy
      if (apiURI) {
        this.voyageForm.vesNo = this.vesNo
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.voyageForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Stay on page
            this.newVoyage = false
            await this.reviewVoyage()
          }

          this.submitting = false
          const commitData = {
            voyageTab: 0,
            displayVoyageReviewTab: false
          }
          this.$store.commit(VESSEL_VOYAGE_TABMENU, commitData)
          this.$router.push({ name: 'vesselVoyages', params: { vesNo: this.vesNo } })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doEstDeptDate() {
      // Format Estimated Departure Date
      if (this.estDeptDate && this.estDeptTime && this.estDeptTime.length === 5) {
        const hr = this.estDeptTime.substring(0, 2)
        const min = this.estDeptTime.substring(3, 5)
        this.estDeptDate = toDate(this.estDeptDate)
        this.estDeptDate.setHours(hr)
        this.estDeptDate.setMinutes(min)
        this.voyageForm.estDeptDate = this.estDeptDate
      }
    }
  },
  created() {
    if (this.voyNo === 'New') {
      this.newVoyage = true
    } else {
      this.doInit()
    }
  },
  props: {
    vesNo: {
      type: String,
      default: ''
    },
    voyNo: {
      type: String,
      default: ''
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
